import Vue from 'vue'
import '@/style.css'
import VueRouter, { RouterOptions } from 'vue-router'
import routes from '@/router'
import store from '@/store'
import { auth, logEv } from '@/firebase'
import { BootstrapVue, IconsPlugin } from 'bootstrap-vue'
import App from '@/App.vue'
import { amountFilter, statFilter, rankFilter } from '@/utils/Filters'

// Import Bootstrap an BootstrapVue CSS files (order is important)
import 'bootstrap/dist/css/bootstrap.css'
import 'bootstrap-vue/dist/bootstrap-vue.css'

Vue.use(VueRouter)
Vue.use(BootstrapVue)
Vue.use(IconsPlugin)

Vue.filter('amount', amountFilter)
Vue.filter('stat', statFilter)
Vue.filter('rank', rankFilter)

Vue.config.productionTip = false

const router = new VueRouter(routes as RouterOptions)
router.beforeEach(async (to, from, next) => {
  const accessRequired = Array.isArray(to.meta?.authRequired)
    ? to.meta?.authRequired
    : to.matched
      .find(r => Array.isArray(r.meta?.authRequired))?.meta?.authRequired
  const userAccess = store.getters['user/userAccess']
  const hasAccess = !Array.isArray(accessRequired) || accessRequired.length === 0
    ? true
    : userAccess && accessRequired.includes(userAccess)
  if (userAccess) {
    if (to.name === 'CashRegisterLogin' || !hasAccess) {
      next({ name: 'CashRegister' })
    } else {
      next()
    }
  } else {
    if (!hasAccess) {
      next({ name: 'CashRegisterLogin' })
    } else {
      next()
    }
  }
  const staticPages = ['Home', 'About', 'Sponsors', 'Corporate', 'Leagues', 'Hoops5x5Challenge', 'Challenge']
  if (staticPages.includes(to.name as string)) {
    logEv(to.name as string)
  }
})

let app: any

auth.onAuthStateChanged(user => {
  if (user) {
    store.commit('user/setUser', user)
    if (window.location.pathname.includes('login')) {
      router.replace({ name: 'CashRegister' })
    }
  } else {
    store.commit('user/setUser', {})
    const isAuthRequired = router.currentRoute.meta?.authRequired || router.currentRoute.matched.findIndex(r => r.meta.authRequired) > -1
    if (isAuthRequired) {
      router.replace({ name: 'CashRegisterLogin' })
    }
  }
  if (!app) {
    app = createApp()
  }
})
const createApp = () => {
  new Vue({
    render: h => h(App),
    router,
    store
  }).$mount('#app')
}
